// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { updateProfleAction } from "../../../redux/actions/user/userAction";
// import { connect } from "react-redux";
// import { DialogLeavingPage } from "../../utils/core/blocknavigation/DialogLeavingPage";
// import { useNavigatingAway } from "../../utils/core/blocknavigation/useNavigatingAway";
// import { Select } from "@mui/material";
// export const EmploymentHistory = (props) => {
//   // console.log(employmentHistoryData);
//   const dispatch = useDispatch();
//   const customStyles = {
//     control: (base, state) => ({
//       ...base,
//       top: "5px",
//       // Overwrittes the different states of border
//       borderColor: state.isFocused ? "#309CCA" : "#309CCA",
//     }),
//   };
//   const [inputData, setInputData] = useState([]);
//   const [employmentHistoryData, setEmploymentHistoryData] = useState([]);
//   const [dateConflict, setDateConflict] = useState(false);
//   const [selectedJobTitle, setSelectedJobTitle] = useState("");
//   const [isEnable, setIsEnable] = useState({
//     save: false,
//   });
//   const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
//     useState(false);
//   const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
//     useNavigatingAway(canShowDialogLeavingPage);
    

//   // ⭐ LIMIT TO MAX 6 COMPANIES
//   const MAX_COMPANIES = 6;
//   const remaining = MAX_COMPANIES - employmentHistoryData.length;


//   const handleAddFormChange = () => {
//     if (employmentHistoryData.length >= MAX_COMPANIES) {
//     alert("You can add up to 6 companies only.");
//     return;
//   }


//     setIsEnable((prevState) => ({ ...prevState, save: true }));
//     setCanShowDialogLeavingPage(true);

//     setEmploymentHistoryData((prevState) => [
//       ...prevState,
//       {
//         company_name: "",
//         from_date: "",
//         to_date: null,
//         till_date: false,
//         selected_job_title: null,
//         job_title_type: null,
//       },
//     ]);
//   };

//   const handleChange = (event, index) => {
//     setIsEnable((prevState) => ({ ...prevState, save: true }));
//     setCanShowDialogLeavingPage(true);

//     const values = [...employmentHistoryData];
//     const { name, value, type, checked } = event.target;

//     if (name === "job_title_type") {
//       values[index].job_title_type = Number(value);
//     } else if (name === "company_name") {
//       // ⭐ LIMIT COMPANY NAME TO 28 CHARACTERS
//       const limitedValue = value.slice(0, 28);
//       values[index].company_name = limitedValue;
//     } else {
//       values[index][name] = type === "checkbox" ? checked : value;

//       if (
//         name === "from_date" &&
//         values[index].to_date &&
//         values[index].from_date === values[index].to_date
//       ) {
//         values[index].to_date = "";
//         alert(
//           "From and To dates cannot be the same. To date has been cleared."
//         );
//       }

//       const selectedFromDate = new Date(values[index].from_date);
//       const currentDate = new Date();
//       if (name === "from_date" && selectedFromDate > currentDate) {
//         values[index].from_date = "";
//         alert("From date cannot be in the future. From date has been cleared.");
//       }

//       const selectedToDate = new Date(values[index].to_date);
//       if (name === "to_date" && selectedToDate > currentDate) {
//         values[index].to_date = "";
//         alert("To date cannot be in the future. To date has been cleared.");
//       }
//     }

//     setEmploymentHistoryData(values);
//   };

//   const handleRemoveFormChange = (index) => {
//     setIsEnable((prevState) => ({
//       ...prevState,
//       save: true,
//     }));
//     setCanShowDialogLeavingPage(true);
//     const values = [...employmentHistoryData];
//     values.splice(index, 1);
//     setEmploymentHistoryData(values);
//   };

//   const handleFormSubmit = (event) => {
//     event.preventDefault();
//     const updateData = {
//       userId: inputData.userId,
//       employmentHistory: employmentHistoryData,
//     };
//     dispatch(updateProfleAction(inputData.userId, updateData));
//     setIsEnable((prevState) => ({ ...prevState, save: false }));
//     setCanShowDialogLeavingPage(false);
//   };

//   useEffect(() => {
//     if (props.profile !== undefined) {
//       const statutory = { userId: props.profile.userId };
//       setInputData(statutory);
//       setEmploymentHistoryData(
//         props.profile.employmentHistory &&
//           props.profile.employmentHistory.length === 0
//           ? [
//               {
//                 company_name: "",
//                 from_date: "",
//                 to_date: "",
//                 till_date: "",
//                 selected_job_title: null,
//                 job_title_type: null,
//               },
//             ]
//           : props.profile.employmentHistory
//       );
//     }
//   }, [props]);

//   return (
//     <div className="row margin-row">
//       <DialogLeavingPage
//         showDialog={showDialogLeavingPage}
//         setShowDialog={setCanShowDialogLeavingPage}
//         confirmNavigation={confirmNavigation}
//         cancelNavigation={cancelNavigation}
//         title={"Employment History"}
//       />
//       <div className="row-icon">
//         <img src="\assets\images\profile-page\icon8.png" alt="" />
//       </div>
//       <div className="col-12 ">
//         <div className="timeline-border-box">
//           <h5>Employment history</h5>
//           <div className="row">
//             {employmentHistoryData &&
//               employmentHistoryData.map((employment_history, index) => {
//                 // ⭐ COMPANY NAME LENGTH FOR COUNTER
//                 const companyNameLength =
//                   (employment_history.company_name || "").length;

//                 return (
//                   <div className="col-12 parent-col" key={index}>
//                     <div className="row cloneRowTarget  ">
//                       <div
//                         className="col-md-3 col-12"
//                         style={{ paddingTop: "1%" }}
//                       >
//                         <label className="field-label">Company Name</label>
//                         <div className="expertise-fields">
//                           <div className="single-field mb-3">
//                             <input
//                               type="text"
//                               className="form-control"
//                               name="company_name"
//                               placeholder="Company Name"
//                               maxLength={28} // ⭐ HTML max length
//                               value={employment_history.company_name || ""} // ⭐ Controlled input
//                               onChange={(event) => handleChange(event, index)}
//                             />
//                             {/* ⭐ LIVE CHARACTER COUNTER */}
//                             <small
//                               style={{
//                                 fontSize: "12px",
//                                 marginTop: "4px",
//                                 display: "block",
//                                 color:
//                                   companyNameLength >= 28
//                                     ? "red"
//                                     : "#6c757d",
//                               }}
//                             >
//                               {companyNameLength}/28 characters used
//                             </small>
//                           </div>
//                         </div>
//                       </div>

//                       <div
//                         className="col-md-2 col-12 "
//                         style={{ paddingTop: "4%" }}
//                       >
//                         <select
//                           className="form-select"
//                           name="job_title_type"
//                           aria-label="Default select example"
//                           style={{
//                             height: "40px",
//                             borderRadius: "5px",
//                             width: "100%",
//                             borderColor: "#2F9CCA",
//                           }}
//                           value={employment_history.job_title_type ?? ""}
//                           onChange={(event) => handleChange(event, index)}
//                         >
//                           <option value="">Choose...</option>
//                           <option value={1}>Primary</option>
//                           <option value={2}>Secondary</option>
//                           <option value={3}>Tertiary</option>
//                         </select>
//                       </div>

//                       <div
//                         className="col-md-3 col-12"
//                         style={{ paddingTop: "1%" }}
//                       >
//                         <label className="field-label">From</label>
//                         <div className="expertise-fields">
//                           <div className="single-field mb-3">
//                             <input
//                               type="date"
//                               className="form-control"
//                               name="from_date"
//                               min="0"
//                               defaultValue={employment_history.from_date}
//                               onChange={(event) => handleChange(event, index)}
//                             />
//                           </div>
//                         </div>
//                       </div>

//                       <div
//                         className="col-md-3 col-12"
//                         style={{ paddingTop: "1%" }}
//                       >
//                         <label className="field-label">To</label>
//                         <div className="expertise-fields">
//                           <div className="single-field mb-3">
//                             <input
//                               type="date"
//                               className="form-control"
//                               name="to_date"
//                               min="0"
//                               defaultValue={employment_history.to_date}
//                               disabled={employment_history.till_date === true}
//                               onChange={(event) => handleChange(event, index)}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="d-flex justify-content-end">
//                       <div
//                         className="col-md-2 col-12"
//                         style={{
//                           paddingTop: "1%",
//                           marginRight: index === 0 ? "30px" : "0",
//                         }}
//                       >
//                         <label className="field-label">To Date</label>
//                         <div className="expertise-fields">
//                           <div className="single-field mb-3 ">
//                             <label className="check-box">
//                               <input
//                                 type="checkbox"
//                                 className="form-control"
//                                 name="till_date"
//                                 defaultChecked={employment_history.till_date}
//                                 onChange={(event) => handleChange(event, index)}
//                               />
//                               <span></span>
//                             </label>
//                           </div>
//                         </div>
//                       </div>

//                       {index !== 0 ? (
//                         <div className="text-right clone-row-btn-holder d-flex flex-row">
//                           <Link
//                             to=""
//                             style={{ cursor: "pointer" }}
//                             onClick={() => handleRemoveFormChange(index)}
//                             className="cloneTargetTrigger"
//                           >
//                             -
//                           </Link>
//                         </div>
//                       ) : (
//                         ""
//                       )}
//                     </div>

//                     <div>
//                       <p
//                         style={{
//                           color: "red",
//                           display: dateConflict ? "" : "none",
//                         }}
//                       >
//                         From and To dates cannot be the same. To date has been
//                         cleared.
//                       </p>
//                     </div>
//                   </div>
//                 );
//               })}

//             {/* ⭐ SHOW + BUTTON ONLY IF LESS THAN 5 COMPANIES */}
//             {employmentHistoryData.length < MAX_COMPANIES && (
//               <div className="col-12 text-right clone-row-btn-holder">
                

//                 <Link
//                   to=""
//                   style={{ cursor: "pointer" }}
//                   onClick={handleAddFormChange}
//                   className="cloneTargetTrigger"
//                 >
//                   +
//                 </Link>
//               </div>
//             )}
//           </div>
//           <br />
//           <div className="col text-right ">
            

//             {isEnable.save ? (
//               <Link className="edit-btn" to="" onClick={handleFormSubmit}>
//                 <span>
//                   <img src="/assets/images/icons/save.png" alt="" />
//                   Save
//                 </span>
//               </Link>
//             ) : (
//               ""
//             )}
//             <p style={{ fontSize: "12px", color: "#555", textAlign: "left" }}>
//               {remaining} remaining
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };


// const mapStateToProps = (state) => {
//   const profile = state.user.profile;
//   const jobTitles = state.admin.jobTitles;

//   return {
//     profile: profile,
//     jobTitles: jobTitles,
//   };
// };
// const mapDispatchToProps = {};

// export default connect(mapStateToProps, mapDispatchToProps)(EmploymentHistory);



////////////////////////////////////////////////////////////////////////////


// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { updateProfleAction } from "../../../redux/actions/user/userAction";
// import { connect } from "react-redux";
// import { DialogLeavingPage } from "../../utils/core/blocknavigation/DialogLeavingPage";
// import { useNavigatingAway } from "../../utils/core/blocknavigation/useNavigatingAway";
// import { Select } from "@mui/material";
// export const EmploymentHistory = (props) => {
//   // console.log(employmentHistoryData);
//   const dispatch = useDispatch();
//   const customStyles = {
//     control: (base, state) => ({
//       ...base,
//       top: "5px",
//       // Overwrittes the different states of border
//       borderColor: state.isFocused ? "#309CCA" : "#309CCA",
//     }),
//   };

//   const [focusedCompanyIndex, setFocusedCompanyIndex] = useState(null);

//   const [inputData, setInputData] = useState([]);
//   const [employmentHistoryData, setEmploymentHistoryData] = useState([]);
//   const [dateConflict, setDateConflict] = useState(false);
//   const [selectedJobTitle, setSelectedJobTitle] = useState("");
//   const [isEnable, setIsEnable] = useState({
//     save: false,
//   });
//   const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
//     useState(false);
//   const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
//     useNavigatingAway(canShowDialogLeavingPage);
    

//   // LIMIT TO MAX 6 COMPANIES
//   const MAX_COMPANIES = 6;
//   const remaining = MAX_COMPANIES - employmentHistoryData.length;
  



//   const handleAddFormChange = () => {
//     if (employmentHistoryData.length >= MAX_COMPANIES) {
//     alert("You can add up to 6 companies only.");
//     return;
//   }


//     setIsEnable((prevState) => ({ ...prevState, save: true }));
//     setCanShowDialogLeavingPage(true);

//     setEmploymentHistoryData((prevState) => [
//       ...prevState,
//       {
//         company_name: "",
//         from_date: "",
//         to_date: null,
//         till_date: false,
//         selected_job_title: null,
//         job_title_type: null,
//       },
//     ]);
//   };

//   const handleChange = (event, index) => {
//     setIsEnable((prevState) => ({ ...prevState, save: true }));
//     setCanShowDialogLeavingPage(true);

//     const values = [...employmentHistoryData];
//     const { name, value, type, checked } = event.target;

//     if (name === "job_title_type") {
//       values[index].job_title_type = Number(value);
//     } else if (name === "company_name") {
//       // LIMIT COMPANY NAME TO 28 CHARACTERS
//       const limitedValue = value.slice(0, 28);
//       values[index].company_name = limitedValue;
//     } else {
//       values[index][name] = type === "checkbox" ? checked : value;

//       if (
//         name === "from_date" &&
//         values[index].to_date &&
//         values[index].from_date === values[index].to_date
//       ) {
//         values[index].to_date = "";
//         alert(
//           "From and To dates cannot be the same. To date has been cleared."
//         );
//       }

//       const selectedFromDate = new Date(values[index].from_date);
//       const currentDate = new Date();
//       if (name === "from_date" && selectedFromDate > currentDate) {
//         values[index].from_date = "";
//         alert("From date cannot be in the future. From date has been cleared.");
//       }

//       const selectedToDate = new Date(values[index].to_date);
//       if (name === "to_date" && selectedToDate > currentDate) {
//         values[index].to_date = "";
//         alert("To date cannot be in the future. To date has been cleared.");
//       }
//     }

//     setEmploymentHistoryData(values);
//   };

//   const handleRemoveFormChange = (index) => {
//     setIsEnable((prevState) => ({
//       ...prevState,
//       save: true,
//     }));
//     setCanShowDialogLeavingPage(true);
//     const values = [...employmentHistoryData];
//     values.splice(index, 1);
//     setEmploymentHistoryData(values);
//   };

//   const handleFormSubmit = (event) => {
//     event.preventDefault();
//     const updateData = {
//       userId: inputData.userId,
//       employmentHistory: employmentHistoryData,
//     };
//     dispatch(updateProfleAction(inputData.userId, updateData));
//     setIsEnable((prevState) => ({ ...prevState, save: false }));
//     setCanShowDialogLeavingPage(false);
//   };

//   useEffect(() => {
//     if (props.profile !== undefined) {
//       const statutory = { userId: props.profile.userId };
//       setInputData(statutory);
//       setEmploymentHistoryData(
//         props.profile.employmentHistory &&
//           props.profile.employmentHistory.length === 0
//           ? [
//               {
//                 company_name: "",
//                 from_date: "",
//                 to_date: "",
//                 till_date: "",
//                 selected_job_title: null,
//                 job_title_type: null,
//               },
//             ]
//           : props.profile.employmentHistory
//       );
//     }
//   }, [props]);

//   return (
//     <div className="row margin-row">
//       <DialogLeavingPage
//         showDialog={showDialogLeavingPage}
//         setShowDialog={setCanShowDialogLeavingPage}
//         confirmNavigation={confirmNavigation}
//         cancelNavigation={cancelNavigation}
//         title={"Employment History"}
//       />
//       <div className="row-icon">
//         <img src="\assets\images\profile-page\icon8.png" alt="" />
//       </div>
//       <div className="col-12 ">
//         <div className="timeline-border-box">
//           <h5>Employment history</h5>
//           <div className="row">
//             {employmentHistoryData &&
//               employmentHistoryData.map((employment_history, index) => {
//                 // COMPANY NAME LENGTH FOR COUNTER
//                 const companyNameLength =
//                   (employment_history.company_name || "").length;

//                 return (
//                   <div className="col-12 parent-col" key={index}>
//                     <div className="row cloneRowTarget  ">
//                       <div
//                         className="col-md-3 col-12"
//                         style={{ paddingTop: "1%" }}
//                       >
//                         <label className="field-label">Company Name</label>
//                         <div className="expertise-fields">
//                           <div className="single-field mb-3">
//                             <input
//                               type="text"
//                               className="form-control"
//                               name="company_name"
//                               placeholder="Company Name"
//                               maxLength={28} // HTML max length
//                               value={employment_history.company_name || ""} // Controlled input
//                               onChange={(event) => handleChange(event, index)}
//                               onFocus={() => setFocusedCompanyIndex(index)}   // Show counter for this row
//                               onBlur={() => setFocusedCompanyIndex(null)}     // Hide counter on blur
//                             />
//                             {/* LIVE CHARACTER COUNTER */}
//                             {focusedCompanyIndex === index && (   // Only show when this input is focused
//                               <small
//                                 style={{
//                                   fontSize: "12px",
//                                   marginTop: "4px",
//                                   display: "block",
//                                   color: companyNameLength >= 28 ? "red" : "#6c757d",
//                                 }}
//                               >
//                                 {/* {companyNameLength}/28 characters used */}
//                                 {28 - companyNameLength} remaining

//                               </small>
//                             )}

//                           </div>
//                         </div>
//                       </div>

//                       <div
//                         className="col-md-2 col-12 "
//                         style={{ paddingTop: "4%" }}
//                       >
//                         <select
//                           className="form-select"
//                           name="job_title_type"
//                           aria-label="Default select example"
//                           style={{
//                             height: "40px",
//                             borderRadius: "5px",
//                             width: "100%",
//                             borderColor: "#2F9CCA",
//                           }}
//                           value={employment_history.job_title_type ?? ""}
//                           onChange={(event) => handleChange(event, index)}
//                         >
//                           <option value="">Choose...</option>
//                           <option value={1}>Primary</option>
//                           <option value={2}>Secondary</option>
//                           <option value={3}>Tertiary</option>
//                         </select>
//                       </div>

//                       <div
//                         className="col-md-3 col-12"
//                         style={{ paddingTop: "1%" }}
//                       >
//                         <label className="field-label">From</label>
//                         <div className="expertise-fields">
//                           <div className="single-field mb-3">
//                             <input
//                               type="date"
//                               className="form-control"
//                               name="from_date"
//                               min="0"
//                               defaultValue={employment_history.from_date}
//                               onChange={(event) => handleChange(event, index)}
//                             />
//                           </div>
//                         </div>
//                       </div>

//                       <div
//                         className="col-md-3 col-12"
//                         style={{ paddingTop: "1%" }}
//                       >
//                         <label className="field-label">To</label>
//                         <div className="expertise-fields">
//                           <div className="single-field mb-3">
//                             <input
//                               type="date"
//                               className="form-control"
//                               name="to_date"
//                               min="0"
//                               defaultValue={employment_history.to_date}
//                               disabled={employment_history.till_date === true}
//                               onChange={(event) => handleChange(event, index)}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="d-flex justify-content-end">
//                       <div
//                         className="col-md-2 col-12"
//                         style={{
//                           paddingTop: "1%",
//                           marginRight: index === 0 ? "30px" : "0",
//                         }}
//                       >
//                         <label className="field-label">To Date</label>
//                         <div className="expertise-fields">
//                           <div className="single-field mb-3 ">
//                             <label className="check-box">
//                               <input
//                                 type="checkbox"
//                                 className="form-control"
//                                 name="till_date"
//                                 defaultChecked={employment_history.till_date}
//                                 onChange={(event) => handleChange(event, index)}
//                               />
//                               <span></span>
//                             </label>
//                           </div>
//                         </div>
//                       </div>

//                       {index !== 0 ? (
//                         <div className="text-right clone-row-btn-holder d-flex flex-row">
//                           <Link
//                             to=""
//                             style={{ cursor: "pointer" }}
//                             onClick={() => handleRemoveFormChange(index)}
//                             className="cloneTargetTrigger"
//                           >
//                             -
//                           </Link>
//                         </div>
//                       ) : (
//                         ""
//                       )}
//                     </div>

//                     <div>
//                       <p
//                         style={{
//                           color: "red",
//                           display: dateConflict ? "" : "none",
//                         }}
//                       >
//                         From and To dates cannot be the same. To date has been
//                         cleared.
//                       </p>
//                     </div>
//                   </div>
//                 );
//               })}

//             {/* SHOW + BUTTON ONLY IF LESS THAN 5 COMPANIES */}
//             {employmentHistoryData.length < MAX_COMPANIES && (
//               <div className="col-12 text-right clone-row-btn-holder">
                

//                 <Link
//                   to=""
//                   style={{ cursor: "pointer" }}
//                   onClick={handleAddFormChange}
//                   className="cloneTargetTrigger"
//                 >
//                   +
//                 </Link>
//               </div>
//             )}
//           </div>
//           <br />
//           <div className="col text-right ">
            

//             {isEnable.save ? (
//               <Link className="edit-btn" to="" onClick={handleFormSubmit}>
//                 <span>
//                   <img src="/assets/images/icons/save.png" alt="" />
//                   Save
//                 </span>
//               </Link>
//             ) : (
//               ""
//             )}
//             <p
//               style={{
//                 fontSize: "12px",
//                 textAlign: "left",
//                 color:  "#555" // red when max reached
//               }}
//             >
//               {remaining > 0
//                 ? `${remaining} remaining`
//                 : "Maximum number of companies added."}
//             </p>

//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };


// const mapStateToProps = (state) => {
//   const profile = state.user.profile;
//   const jobTitles = state.admin.jobTitles;

//   return {
//     profile: profile,
//     jobTitles: jobTitles,
//   };
// };
// const mapDispatchToProps = {};

// export default connect(mapStateToProps, mapDispatchToProps)(EmploymentHistory);



////////////////////////////////////////////////white//////////////////////


import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateProfleAction } from "../../../redux/actions/user/userAction";
import { connect } from "react-redux";
import { DialogLeavingPage } from "../../utils/core/blocknavigation/DialogLeavingPage";
import { useNavigatingAway } from "../../utils/core/blocknavigation/useNavigatingAway";
import { Select } from "@mui/material";
export const EmploymentHistory = (props) => {
  // console.log(employmentHistoryData);
  const dispatch = useDispatch();
  const customStyles = {
    control: (base, state) => ({
      ...base,
      top: "5px",
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "#309CCA" : "#309CCA",
    }),
  };

  const [focusedCompanyIndex, setFocusedCompanyIndex] = useState(null);

  const [inputData, setInputData] = useState([]);
  const [employmentHistoryData, setEmploymentHistoryData] = useState([]);
  const [dateConflict, setDateConflict] = useState(false);
  const [selectedJobTitle, setSelectedJobTitle] = useState("");
  const [isEnable, setIsEnable] = useState({
    save: false,
  });
  const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
    useState(false);
  const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
    useNavigatingAway(canShowDialogLeavingPage);
    

  // LIMIT TO MAX 6 COMPANIES
  const MAX_COMPANIES = 6;
  // const remaining = MAX_COMPANIES - employmentHistoryData.length;
  const remaining = MAX_COMPANIES - (employmentHistoryData?.length || 0);



  const handleAddFormChange = () => {
    if (employmentHistoryData.length >= MAX_COMPANIES) {
    alert("You can add up to 6 companies only.");
    return;
  }


    setIsEnable((prevState) => ({ ...prevState, save: true }));
    setCanShowDialogLeavingPage(true);

    setEmploymentHistoryData((prevState) => [
      ...prevState,
      {
        company_name: "",
        from_date: "",
        to_date: null,
        till_date: false,
        selected_job_title: null,
        job_title_type: null,
      },
    ]);
  };

  const handleChange = (event, index) => {
    setIsEnable((prevState) => ({ ...prevState, save: true }));
    setCanShowDialogLeavingPage(true);

    const values = [...employmentHistoryData];
    const { name, value, type, checked } = event.target;

    if (name === "job_title_type") {
      values[index].job_title_type = Number(value);
    } else if (name === "company_name") {
      // LIMIT COMPANY NAME TO 28 CHARACTERS
      const limitedValue = value.slice(0, 28);
      values[index].company_name = limitedValue;
    } else {
      values[index][name] = type === "checkbox" ? checked : value;

      if (
        name === "from_date" &&
        values[index].to_date &&
        values[index].from_date === values[index].to_date
      ) {
        values[index].to_date = "";
        alert(
          "From and To dates cannot be the same. To date has been cleared."
        );
      }

      const selectedFromDate = new Date(values[index].from_date);
      const currentDate = new Date();
      if (name === "from_date" && selectedFromDate > currentDate) {
        values[index].from_date = "";
        alert("From date cannot be in the future. From date has been cleared.");
      }

      const selectedToDate = new Date(values[index].to_date);
      if (name === "to_date" && selectedToDate > currentDate) {
        values[index].to_date = "";
        alert("To date cannot be in the future. To date has been cleared.");
      }
    }

    setEmploymentHistoryData(values);
  };

  const handleRemoveFormChange = (index) => {
    setIsEnable((prevState) => ({
      ...prevState,
      save: true,
    }));
    setCanShowDialogLeavingPage(true);
    const values = [...employmentHistoryData];
    values.splice(index, 1);
    setEmploymentHistoryData(values);
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const updateData = {
      userId: inputData.userId,
      employmentHistory: employmentHistoryData,
    };
    dispatch(updateProfleAction(inputData.userId, updateData));
    setIsEnable((prevState) => ({ ...prevState, save: false }));
    setCanShowDialogLeavingPage(false);
  };

  useEffect(() => {
    if (props.profile !== undefined) {
      const statutory = { userId: props.profile.userId };
      setInputData(statutory);
      const history = Array.isArray(props.profile?.employmentHistory)
        ? props.profile.employmentHistory
        : [];

      setEmploymentHistoryData(
        history.length === 0
          ? [
              {
                company_name: "",
                from_date: "",
                to_date: "",
                till_date: "",
                selected_job_title: null,
                job_title_type: null,
              },
            ]
          : history
      );

    }
  }, [props]);

  return (
    <div className="row margin-row">
      <DialogLeavingPage
        showDialog={showDialogLeavingPage}
        setShowDialog={setCanShowDialogLeavingPage}
        confirmNavigation={confirmNavigation}
        cancelNavigation={cancelNavigation}
        title={"Employment History"}
      />
      <div className="row-icon">
        <img src="\assets\images\profile-page\icon8.png" alt="" />
      </div>
      <div className="col-12 ">
        <div className="timeline-border-box">
          <h5>Employment history</h5>
          <div className="row">
            {employmentHistoryData &&
              employmentHistoryData.map((employment_history, index) => {
                // COMPANY NAME LENGTH FOR COUNTER
                const companyNameLength =
                  (employment_history.company_name || "").length;

                return (
                  <div className="col-12 parent-col" key={index}>
                    <div className="row cloneRowTarget  ">
                      <div
                        className="col-md-3 col-12"
                        style={{ paddingTop: "1%" }}
                      >
                        <label className="field-label">Company Name</label>
                        <div className="expertise-fields">
                          <div className="single-field mb-3">
                            <input
                              type="text"
                              className="form-control"
                              name="company_name"
                              placeholder="Company Name"
                              maxLength={28} // HTML max length
                              value={employment_history.company_name || ""} // Controlled input
                              onChange={(event) => handleChange(event, index)}
                              onFocus={() => setFocusedCompanyIndex(index)}   // Show counter for this row
                              onBlur={() => setFocusedCompanyIndex(null)}     // Hide counter on blur
                            />
                            {/* LIVE CHARACTER COUNTER */}
                            {focusedCompanyIndex === index && (   // Only show when this input is focused
                              <small
                                style={{
                                  fontSize: "12px",
                                  marginTop: "4px",
                                  display: "block",
                                  color: companyNameLength >= 28 ? "red" : "#6c757d",
                                }}
                              >
                                {/* {companyNameLength}/28 characters used */}
                                {28 - companyNameLength} remaining

                              </small>
                            )}

                          </div>
                        </div>
                      </div>

                      <div
                        className="col-md-2 col-12 "
                        style={{ paddingTop: "4%" }}
                      >
                        <select
                          className="form-select"
                          name="job_title_type"
                          aria-label="Default select example"
                          style={{
                            height: "40px",
                            borderRadius: "5px",
                            width: "100%",
                            borderColor: "#2F9CCA",
                          }}
                          value={employment_history.job_title_type ?? ""}
                          onChange={(event) => handleChange(event, index)}
                        >
                          <option value="">Choose...</option>
                          <option value={1}>Primary</option>
                          <option value={2}>Secondary</option>
                          <option value={3}>Tertiary</option>
                        </select>
                      </div>

                      <div
                        className="col-md-3 col-12"
                        style={{ paddingTop: "1%" }}
                      >
                        <label className="field-label">From</label>
                        <div className="expertise-fields">
                          <div className="single-field mb-3">
                            <input
                              type="date"
                              className="form-control"
                              name="from_date"
                              min="0"
                              defaultValue={employment_history.from_date}
                              onChange={(event) => handleChange(event, index)}
                            />
                          </div>
                        </div>
                      </div>

                      <div
                        className="col-md-3 col-12"
                        style={{ paddingTop: "1%" }}
                      >
                        <label className="field-label">To</label>
                        <div className="expertise-fields">
                          <div className="single-field mb-3">
                            <input
                              type="date"
                              className="form-control"
                              name="to_date"
                              min="0"
                              defaultValue={employment_history.to_date}
                              disabled={employment_history.till_date === true}
                              onChange={(event) => handleChange(event, index)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div
                        className="col-md-2 col-12"
                        style={{
                          paddingTop: "1%",
                          marginRight: index === 0 ? "30px" : "0",
                        }}
                      >
                        <label className="field-label">To Date</label>
                        <div className="expertise-fields">
                          <div className="single-field mb-3 ">
                            <label className="check-box">
                              <input
                                type="checkbox"
                                className="form-control"
                                name="till_date"
                                defaultChecked={employment_history.till_date}
                                onChange={(event) => handleChange(event, index)}
                              />
                              <span></span>
                            </label>
                          </div>
                        </div>
                      </div>

                      {index !== 0 ? (
                        <div className="text-right clone-row-btn-holder d-flex flex-row">
                          <Link
                            to=""
                            style={{ cursor: "pointer" }}
                            onClick={() => handleRemoveFormChange(index)}
                            className="cloneTargetTrigger"
                          >
                            -
                          </Link>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>

                    <div>
                      <p
                        style={{
                          color: "red",
                          display: dateConflict ? "" : "none",
                        }}
                      >
                        From and To dates cannot be the same. To date has been
                        cleared.
                      </p>
                    </div>
                  </div>
                );
              })}

            {/* SHOW + BUTTON ONLY IF LESS THAN 5 COMPANIES */}
            {employmentHistoryData.length < MAX_COMPANIES && (
              <div className="col-12 text-right clone-row-btn-holder">
                

                <Link
                  to=""
                  style={{ cursor: "pointer" }}
                  onClick={handleAddFormChange}
                  className="cloneTargetTrigger"
                >
                  +
                </Link>
              </div>
            )}
          </div>
          <br />
          <div className="col text-right ">
            

            {isEnable.save ? (
              <Link className="edit-btn" to="" onClick={handleFormSubmit}>
                <span>
                  <img src="/assets/images/icons/save.png" alt="" />
                  Save
                </span>
              </Link>
            ) : (
              ""
            )}
            <p
              style={{
                fontSize: "12px",
                textAlign: "left",
                color:  "#555" // red when max reached
              }}
            >
              {remaining > 0
                ? `${remaining} remaining`
                : "Maximum number of companies added."}
            </p>

          </div>
        </div>
      </div>
    </div>
  );
};


const mapStateToProps = (state) => {
  const profile = state.user.profile;
  const jobTitles = state.admin.jobTitles;

  return {
    profile: profile,
    jobTitles: jobTitles,
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EmploymentHistory);
